export default __webpack_public_path__ + "static/media/phone-rounded-svgrepo-com.717d2e0d.svg";